<template>
<div class="chapter">
<div class="inner_page">
<p class="chapnum"><a id="pg13">1</a></p><a id="pg13">
<p class="chaptit">Bachelor Creek Torpedo Explosion, 1864</p>
<p class="noindent">On May 27, 1864, at about 4:00 p.m. a train carrying four torpedoes pulled into the Bachelor Creek, North Carolina train station. The train left New Bern, North Carolina at 3:00 p.m. and arrived on time at Bachelor Creek. These four torpedoes were scheduled to complete the blockade of the Neuse River. The first three torpedoes were unloaded without incident. As the fourth was nearing the station platform, everything was looking good until a stick of wood hit the cap. Disaster followed.</p>
<p class="indent">The explosion of the fourth torpedo was so great that it caused the other three to simultaneously explode. The explosion of the four torpedoes was so fast that it sounded like one great explosion.</p>
<p class="indent">Many soldiers were standing around the train station waiting on news from Virginia. These soldiers, along with others at the station, were blown into eternity. Body parts were blown for a quarter of a mile around. Many could not be recognized.</p>
<p class="indent">The building suffered severe damage from the torpedoes’ explosion. The signal tower and commissary building were built out of logs that were thrown as much as eight hundred feet from the explosion.</p>
<p class="indent">Forty men were killed in the explosion, and many others were seriously injured.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter01.vue?5fe0ae9a